<template>
	<div class="home">
		<div class="search_line">
			<div class="first_search_line">
				<el-autocomplete v-if="userType=='admin'" class="auto_comp" clearable v-model="state"
					:fetch-suggestions="querySearch" size="mini" placeholder="请输入学校" />
				<el-input style="width: 200px;margin-left: 20px;margin-right: 20px;" clearable
					v-model="search_data.name" size="mini" placeholder="教师姓名" />
				<!-- 				<el-input style="width: 200px;margin-right: 20px;"  clearable v-model="search_data.workid" size="mini"
					placeholder="教师工号" /> -->
				<el-input style="width: 200px;margin-right: 20px;" clearable v-model="search_data.phone" size="mini"
					placeholder="教师手机号" />

			</div>
			<div class="second_search_line">
				<el-button class="search_bt" type="danger" icon="el-icon-search" size="mini" @click="search(state)">
					搜索
				</el-button>
				<el-button class="search_bt" type="primary" icon="el-icon-plus" size="mini" @click="handleAdd()"
					v-if="userinfo.permit!='1'">
					添加
				</el-button>
				<el-button class="export_bt" type="success" icon="el-icon-download" size="mini"
					@click="exportTeacher()">
					导出
				</el-button>
			</div>
		</div>
		<el-table :data="tableData" :header-cell-style="{background:'#409EFF',color:'white'}" size="mini">
			<el-table-column prop="schoolName" label="学校" width="280" />
			<el-table-column prop="realname" label="姓名" />
			<el-table-column prop="male" label="性别" />
			<!-- <el-table-column prop="workId" label="工号" /> -->
			<el-table-column prop="phone" label="电话" />
			<el-table-column prop="username" label="用户名" />
			<!-- <el-table-column prop="editTime" label="修改时间" /> -->
			<el-table-column prop="edit" label="修改" width="60" v-if="userinfo.permit!='1'">
				<template slot-scope="scope">
					<el-button @click="handleEdit(scope.row)" type="text" size="mini" class="edit_bt"><i
							class="el-icon-edit-outline"></i></el-button>
				</template>
			</el-table-column>
			<el-table-column prop="delete" label="删除" width="60" v-if="userinfo.permit!='1'">
				<template slot-scope="scope">
					<el-button type="text" size="mini" class="delete_bt" @click="handleDelete(scope.row)"><i
							class="el-icon-delete"></i>
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination">
			<el-pagination background layout="total, prev, pager, next" @current-change="handleCurrentChange"
				:total="total_num">
			</el-pagination>
		</div>
		<el-dialog title="添加教师" :visible.sync="dialogteacherAddVisible" top="5vh">
			<div class="input_title">
				<span>教师姓名</span>
				<span v-show="showTip">
					<font>{{result}}</font>
				</span>
			</div>
			<div>
				<el-input size="small" placeholder="请输入教师姓名" v-model="teacher_name" suffix-icon="el-icon-s-custom"
					autofocus="true" @focus="showTip=false" />
			</div>
			<div class="input_title">
				<span>学校</span>
			</div>
			<div>
				<el-autocomplete v-if="userType=='admin'" clearable v-model="school_name"
					:fetch-suggestions="querySearch" placeholder="请输入学校名称" size="small" class="school_select" />
				<el-input size="small" v-if="userType=='school'" v-model="school.schoolName"
					suffix-icon="el-icon-s-custom" autofocus="true" @focus="showTip=false" disabled />
			</div>
			<div class="input_title">
				<span>性别</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select class="male_select" v-model="male" placeholder="请选择性别" size="small">
					<el-option v-for="item in ['男','女']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>
			<!-- 			<div class="input_title">
				<span>工号</span>
			</div>
			<div>
				<el-input size="small" v-model="workId" suffix-icon="el-icon-s-grid" placeholder="请输入教师工号" />
			</div> -->
			<div class="input_title">
				<span>电话</span>
			</div>
			<div>
				<el-input size="small" v-model="phone" suffix-icon="el-icon-phone-outline" @focus="showTip=false"
					placeholder="请输入电话号码" />
			</div>
			<div class="input_title">
				<span>用户名</span>
			</div>
			<div>
				<el-input size="small" v-model="username" suffix-icon="el-icon-user-solid" placeholder="请设置用户名"
					@focus="showTip=false" />
			</div>
			<div class="input_title">
				<span>密码</span>
			</div>
			<div>
				<el-input size="small" v-model="password" show-password auto-complete="new-password"
					placeholder="请设置密码" />
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="dialogteacherAddVisible = false">
					取 消
				</el-button>
				<el-button size="small" type="primary" @click="add()">
					确 定
				</el-button>
			</div>
		</el-dialog>
		<el-dialog title="修改" :visible.sync="dialogteacherEditVisible" top="5vh">
			<div class="input_title">
				<span>教师姓名</span>
				<span v-show="showTip">
					<font>{{result}}</font>
				</span>
			</div>
			<div>
				<el-input size="small" placeholder="请输入教师姓名" v-model="teacher_name" suffix-icon="el-icon-s-custom"
					autofocus="true" @focus="showTip=false" />
			</div>
			<div class="input_title">
				<span>学校</span>
			</div>
			<div>
				<el-autocomplete v-if="userType=='admin'" clearable v-model="school_name"
					:fetch-suggestions="querySearch" :trigger-on-focus="false" placeholder="请输入学校名称" size="small"
					class="school_select" />
				<el-input size="small" v-if="userType=='school'" v-model="school.schoolName"
					suffix-icon="el-icon-s-custom" autofocus="true" @focus="showTip=false" disabled />
			</div>
			<div class="input_title">
				<span>性别</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select class="male_select" v-model="male" placeholder="请选择性别" size="small">
					<el-option v-for="item in ['男','女']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>
			<!-- 			<div class="input_title">
				<span>工号</span>
			</div>
			<div>
				<el-input size="small" v-model="workId" suffix-icon="el-icon-s-grid" placeholder="请输入教师工号" />
			</div> -->
			<div class="input_title">
				<span>电话</span>
			</div>
			<div>
				<el-input size="small" v-model="phone" suffix-icon="el-icon-phone-outline" @focus="showTip=false"
					placeholder="请输入电话号码" />
			</div>
			<div class="input_title">
				<span>用户名</span>
			</div>
			<div>
				<el-input size="small" v-model="username" suffix-icon="el-icon-user-solid" placeholder="请设置用户名"
					@focus="showTip=false" />
			</div>
			<div class="input_title">
				<span>密码</span>
			</div>
			<div>
				<el-input size="small" v-model="password" show-password auto-complete="new-password"
					placeholder="请设置密码" />
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="dialogteacherEditVisible = false">
					取 消
				</el-button>
				<el-button size="small" type="primary" @click="edit()">
					确 定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "teacher",
		data() {
			return {
				state: '',
				tableData: [],
				total_num: 0,
				dialogteacherAddVisible: false,
				teacher_name: '',
				school_name: '',
				male: '',
				workId: '',
				username: '',
				password: '',
				phone: '',
				showTip: false,
				result: '',
				dialogteacherEditVisible: false,
				id: '',
				userType: window.localStorage.getItem("userType"),
				userinfo: '',
				school: '',
				search_data: {
					name: '',
					workid: '',
					phone: '',
				}
			};
		},
		mounted() {
			this.getteacherInfo();
		},
		methods: {
			getteacherInfo(page) {
				page = !page ? 1 : page
				name = !this.state ? '' : this.state
				var teacher_name = this.search_data.name
				var workid = this.search_data.workid
				var phone = this.search_data.phone
				const that = this
				this.$axios({
					url: '/jfapi/getteacherInfo?page=' + page + '&school_name=' + name + '&teacher_name=' +
						teacher_name + '&userType=' + that.userType + '&workid=' + workid + '&phone=' + phone,
				}).then(function(res) {
					// console.log(res.data)
					that.tableData = res.data.records
					that.total_num = res.data.total
				});

				if (that.userType == 'school') {
					that.$axios({
						url: '/jfapi/getSchool'
					}).then(function(res) {
						that.school = res.data
					});
				}

				// 获取用户信息
				that.$axios({
					url: '/jfapi/userinfo/' + that.userType
				}).then(function(res) {
					that.userinfo = res.data
				})

			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getteacherInfo(val, this.state)
			},
			querySearch(queryString, cb) {
				this.$axios({
					url: '/jfapi/getSchollHint?queryString=' + queryString,
				}).then(function(res) {
					cb(res.data)
				});
			},
			search(name) {
				// if (!name)
				// 	return
				this.getteacherInfo(1, name)
			},
			handleAdd(row) {
				this.showTip = false
				this.dialogteacherAddVisible = true
				this.teacher_name = ''
				this.school_name = ''
				this.male = ''
				// this.workId = ''
				this.phone = ''
				this.username = ''
				this.password = ''
			},
			add() {
				if (this.userType == 'school') {
					this.school_name = this.school.schoolName
				}
				if (this.teacher_name == '' || this.school_name == '' || this.male == '' || this.wordId == '' || this
					.username == '' || this.password == '' || this.phone == '') {
					this.result = "请填写完整!"
					this.showTip = true
					return
				}
				// 校验密码强度
				if (this.pwdStrong(this.password) == false) {
					this.result = "密码不能少于8位，且必须至少包含两种字符（数字、大小写字母、其它符号）！"
					this.showTip = true
					return
				}
				let data = {
					realname: this.teacher_name,
					school_name: this.school_name,
					username: this.username,
					password: this.password,
					phone: this.phone,
					male: this.male,
					// workId: this.workId,
					userType: this.userType,
				}
				// console.log(data)
				const that = this
				this.$axios({
					method: 'post',
					url: '/jfapi/addTeacher',
					data: that.qs.stringify(data)
				}).then(function(res) {
					// console.log(res.data)
					if (res.data == 'success') {
						that.getteacherInfo()
						that.dialogteacherAddVisible = false
					} else {
						that.result = res.data
						that.showTip = true
					}
				});
			},
			handleEdit(row) {
				// console.log(row)
				this.showTip = false
				this.dialogteacherEditVisible = true
				this.teacher_name = row.realname
				this.school_name = row.schoolName
				this.male = row.male
				this.workId = row.workId
				this.username = row.username
				this.password = row.password
				this.phone = row.phone
				this.id = row.id
			},
			handleDelete(row) {
				var r = confirm("确认删除吗？");
				if (r == true) {
					const that = this
					this.$axios({
						url: '/jfapi/delTeacher?id=' + row.id + '&userType=' + that.userType,
					}).then(function(res) {
						that.getteacherInfo()
					});
				}

			},
			edit() {
				if (this.teacher_name == '' || this.school_name == '' || this.phone == '' || this.username == '' || this
					.password == '' || this
					.phone == '') {
					this.result = "请填写完整!"
					this.showTip = true
					return
				}
				// 校验密码强度
				if (this.pwdStrong(this.password) == false) {
					this.result = "密码不能少于8位，且必须至少包含两种字符（数字、大小写字母、其它符号）！"
					this.showTip = true
					return
				}
				let data = {
					realname: this.teacher_name,
					school_name: this.school_name,
					username: this.username,
					password: this.password,
					phone: this.phone,
					male: this.male,
					workId: this.workId,
					userType: this.userType,
					id: this.id,

				}
				const that = this
				this.$axios({
					method: 'post',
					url: '/jfapi/editTeacher',
					data: that.qs.stringify(data)
				}).then(function(res) {
					if (res.data == 'success') {
						that.getteacherInfo()
						that.dialogteacherEditVisible = false
					} else {
						that.result = res.data
						that.showTip = true
					}
				});
			},
			exportTeacher() {
				window.location.href = '/jfapi/exportTeacher?school_name=' + this.state + '&userType=' + this.userType
			},
			pwdStrong(pwd) {
				function charType(num) {
					if (num >= 48 && num <= 57) {
						return 1;
					}
					if (num >= 97 && num <= 122) {
						return 2;
					}
					if (num >= 65 && num <= 90) {
						return 4;
					}
					return 8;
				}
				var len = pwd.length;
				if (len < 8)
					return false
				var result = 0
				for (var i = 0; i < len; i++) {
					result |= charType(pwd.charCodeAt(i));
				}
				var level = 0;
				//对result进行四次循环，计算其level
				for (var i = 0; i <= 4; i++) {
					if (result & 1) {
						level++;
					}
					//右移一位
					result = result >>> 1;
				}

				if (pwd.length >= 6 && level > 1) {
					return true
				} else {
					return false
				}
			},
		}
	};
</script>

<style lang="scss" scoped>
	.search_line {
		display: flex;
		width: 90%;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-left: 10px;
		padding-right: 10px;
	}

	.first_search_line {
		width: 100%;
		display: flex;
		margin-left: 22px;
		justify-content: flex-start;
	}

	.second_search_line {
		width: 80%;
		display: flex;
		justify-content: flex-start;
		margin-left: 18px;
		margin-top: 10px;
	}

	.auto_comp {
		width: 250px;
	}

	.auto_comp .el-input {
		width: 80%;
	}

	input {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.search_bt {
		margin-left: 5px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.export_bt {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.el-table {
		margin-top: 10px;
		font-size: small;
		width: 96%;
		margin-left: 2%;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) // box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}

	.edit_bt {
		color: #00ff7f;
	}

	.delete_bt {
		color: red;
	}

	.pagination {
		width: 90%;
		margin-left: 5%;
		margin-top: 10px;
		display: flex;
		justify-content: flex-end;
	}

	.input_title span {
		margin: 0;
		color: #959595;
		font-size: 10px;
	}

	.input_title {
		display: flex;
		justify-content: space-between;
		width: 80%;
		margin-left: 10%;
		margin-top: 10px;
	}

	// .el-input {
	// 	width: 80%;
	// }

	.el-input__inner:focus {
		border-color: #00b27a;
	}

	.el-dialog__body {
		padding: 0;
	}

	.el-dialog {
		width: 40%;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	font {
		color: #ff0000;
		margin-right: 10px;
	}

	.male_select {
		width: 80%;
	}

	.el-dialog div .el-input {
		width: 80%;
	}

	.school_select {
		width: 80%;
	}
</style>
